<template>
  <div class="point-link">
    <SvgIcon
      :class="`point-link__icon ${iconColor}`"
      :width="iconSize"
      :height="iconSize"
      :icon="icon"
    />
    <div class="point-link__dash" v-show="!hiddenTail">
      <canvas id="point-link-canvas"></canvas>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stage',
  props: {
    hiddenTail: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: String,
      default: '12'
    },
    status: {}
  },
  computed: {
    defaultIcon() {
      return this.status === undefined
    },
    iconColor() {
      if (!this.defaultIcon) {
        if (this.status) return 'success-stage'
        else return 'warning-stage'
      }

      return 'waiting-stage'
    },
    icon() {
      if (!this.defaultIcon) {
        if (this.status) return 'check-circle-outline'
        else return 'alert-circle-outline'
      }

      return 'radiobox-marked'
    }
  },
  mounted() {
    const element = this.$el.querySelector('#point-link-canvas')
    if (element) {
      const ctx = element.getContext('2d')
      const width = element.width

      ctx.lineWidth = 500
      ctx.beginPath()
      ctx.moveTo(0, 0)
      ctx.lineTo(width, 0)
      ctx.strokeStyle = '#dfdfdf'
      ctx.stroke()
    }
  }
}
</script>

<style lang="scss" scoped>
.point-link {
  position: relative;

  .point-link__dash {
    position: absolute;
    height: 2px;
    width: 16px;
    margin: auto 0;
    top: 0;
    left: 94%;

    canvas {
      height: 100%;
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.point-link__icon {
  &.success-stage {
    svg {
      path {
        fill: #1aaa55;
      }
    }
  }

  &.warning-stage {
    svg {
      path {
        fill: #fc9403;
      }
    }
  }

  &.waiting-stage {
    svg {
      path {
        fill: #dad8d8;
      }
    }
  }
}
</style>
